
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiCheckMixed as ObiCheckMixedElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-check-mixed.js';
 
 
 

 
 export const ObiCheckMixed = createComponent({
   react: React,
   tagName: 'obi-check-mixed',
   elementClass: ObiCheckMixedElement,
   events: {
     
   }
  });
 
 